import classNames from "classnames"
import React, { useState, useRef } from "react"
import { usePopper } from "react-popper"

import Typography from "./Typography"
import { Color } from "../../../constants/V2/color"

import { getAccentColor, getBackgroundColorClass } from "@utils/V2/color"

type Props = {
  showTooltipCondition?: "hoverContent" | "hoverContentEllipsed"
  text: string
  backgroundColor: Color
  children: React.ReactNode
}

const Tooltip = ({
  showTooltipCondition = "hoverContent",
  text,
  backgroundColor,
  children,
}: Props) => {
  const [refElement, setRefElement] = useState<HTMLDivElement | null>(null)
  const popperElement = useRef<HTMLDivElement>(null)
  const { styles, attributes } = usePopper(refElement, popperElement.current, {
    placement: "right",
    modifiers: [
      {
        name: "preventOverflow",
        options: {
          padding: 5,
        },
      },
    ],
  })

  return (
    <div className="group">
      <div
        onMouseEnter={(e) => {
          if (
            showTooltipCondition === "hoverContentEllipsed" &&
            popperElement.current
          ) {
            const TooltipContent = e.target as HTMLElement
            if (
              TooltipContent &&
              TooltipContent.scrollHeight > TooltipContent.clientHeight
            ) {
              popperElement.current.classList.add("group-hover:opacity-100")
            } else {
              popperElement.current.classList.remove("group-hover:opacity-100")
            }
          }
        }}
        ref={(e) => setRefElement(e)}
      >
        {children}
      </div>
      <div
        ref={popperElement}
        style={styles.popper}
        className={classNames(
          "pointer-events-none z-10 opacity-0 shadow-md transition-opacity duration-300",
          { "group-hover:opacity-100": showTooltipCondition === "hoverContent" }
        )}
        {...attributes.popper}
      >
        <Typography
          text={text}
          weight="book"
          size="body-sm"
          font="grotesk"
          color={getAccentColor(backgroundColor)}
          className={classNames(
            getBackgroundColorClass(backgroundColor),
            "w-max rounded-8 px-16 py-8"
          )}
        />
      </div>
    </div>
  )
}

export default Tooltip
